import { action } from '@ember/object';
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';

class SettingsTagsEditRoute extends Route {
  @service declare store: any;
  @service declare router: any;

  model({ theme_id }: { theme_id: string }) {
    return this.store.findRecord('theme', theme_id);
  }

  @action
  error(error: { code?: string }) {
    if (error.code === 'NotFoundError') {
      this.router.replaceWith('settings.tags');
    } else {
      // Let the route above this handle the error.
      return true;
    }
  }
}

export default instrumentRoutePerformance(SettingsTagsEditRoute);
